import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import {
  statusRender,
  statusRenderReceipt,
  statusRenderStatusDelivery,
} from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";
import {
  fetchManualFinishCart,
  fetchReceiptList,
  fetchManualFiscalization,
  fetchManualChangeStatusDelivery,
} from "../actions/user";
import { Checkbox } from "@mui/material";

const ReceiptList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { receiptList } = useSelector((state) => state.userReducer);

  //breadcrumb
  const translateModule = "receipt";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchReceiptList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id) return null;
    return (
      <ButtonColumn
        editLinkDetail={`/receipt-edit/` + params.data.id}
        // actionPlay={params.data.status == "PENDING" ? true : false}
        fiscalizationPlay={
          params.data.status === "PAID" && params.data.fiscalized === false
        }
        deleteItemId={params.data.id}
        textToltipDetail={"Detaljan pregled kupovine"}
        value={params}
        activeItemTitle={params.data.receiptNumber}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId, typeAction) => {
    if (typeAction === "active") {
      dispatch(fetchManualFinishCart(pageId));
    } else if (typeAction === "fiscalization") {
      dispatch(fetchManualFiscalization(pageId));
    }
  };

  const handleDeliverToggle = (receiptId, checked, row) => {
    // primer 1: samo kad je checked
    if (checked) {
      dispatch(fetchManualChangeStatusDelivery(receiptId));
    }
    // primer 2: ako imaš posebnu akciju:
    // dispatch(setDeliverStatus({ id: receiptId, delivered: checked }));
  };

  const deliveryCheckboxRenderer = (params) => {
    const row = params.data;
    if (!row?.id) return null;

    const checked = row.deliverStatus === "DELIVERED";

    // (opciono) zabrani menjanje u nekim stanjima
    const disabled = row.status === "PENDING"; // primer

    return (
      <Checkbox
        size="small"
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          const nextChecked = e.target.checked;
          handleDeliverToggle(row.id, nextChecked, row);
        }}
        onClick={(e) => e.stopPropagation()}
        sx={{
          padding: 0,
        }}
      />
    );
  };

  const columnDefs = [
    {
      headerName: "Broj kupovine",
      field: "receiptNumber",
      filter: "agTextColumnFilter",
      minWidth: 200,
      flex: 1,
    },
    {
      headerName: "Ime korisnika",
      field: "name",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Prezime korisnika",
      field: "surname",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Ukupan iznos",
      field: "totalPrice",
      filter: "agNumberColumnFilter",
      width: 160,
    },
    {
      headerName: "Dostava",
      field: "shippingPrice",
      filter: "agNumberColumnFilter",
      width: 120,
    },
    {
      headerName: "Status",
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRenderReceipt,
      width: 180,
      valueGetter: (params) => {
        if (params.data?.status === "PAID") return "Plaćeno";
        if (params.data?.status === "DECLINE") return "Odbijeno";
        if (params.data?.status === "PENDING") return "Čeka plaćanje";
        if (params.data?.status === "ON_DELIVERY") return "Pouzećem";
        return "";
      },
    },
    {
      headerName: "Isporučeno",
      field: "deliverStatus",
      width: 140,
      filter: "agSetColumnFilter",
      sortable: true,
      cellRenderer: deliveryCheckboxRenderer,
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      headerName: "Status isporuke",
      field: "deliverStatus",
      filter: "agSetColumnFilter",
      cellRenderer: statusRenderStatusDelivery,
      width: 180,
      valueGetter: (params) => {
        if (params.data?.deliverStatus === "DELIVERED") return "Isporučeno";
        if (params.data?.deliverStatus === "PENDING") return "Nije isporučeno";
        return "";
      },
    },
    createDateColumn("Datum kupovine", "createdAt"),
    {
      headerName: "Grad",
      field: "city",
      filter: "agTextColumnFilter",
      width: 180,
    },
    {
      headerName: "Adresa",
      field: "address",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Telefon",
      field: "phone",
      filter: "agTextColumnFilter",
      width: 160,
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 60,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchReceiptList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={receiptList}
        columnDefs={columnDefs}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="receipt-list"
      />
    </Fragment>
  );
};

export default ReceiptList;
